import { api } from 'utility';
import { fileDownloader } from 'utility/util';
import {
  getAllBusinessInfoUrl,
  gerReportMyServiceCallUrl,
  getReportTotalMyServiceCallUrl,
  getConfirmServiceCallApiKeyUrl,
  getConfirmApiKeyListUrl,
  getRevokeApiKeyUrl,
  getExportReceivedServiceSetUrl,
  getReceivedServiceSetUrl,
} from 'URLs';

export function receivedServiceSetApi(data, params) {
  return api.post(getReceivedServiceSetUrl(), data, { params }).then((res) => res.data);
}

export function receivedServiceSetApiExport(data, params, type, onError) {
  return fileDownloader(
    'POST',
    getExportReceivedServiceSetUrl(type),
    params,
    data,
    null,
    type,
    null,
    onError,
  );
}

export function getMyServiceCallApi(data, params) {
  return api.post(gerReportMyServiceCallUrl(), data, { params }).then((res) => res.data);
}

export function getTotalMyServiceCall(id) {
  return api.get(getReportTotalMyServiceCallUrl(id)).then((res) => res.data);
}

export function confirmRequestApi(data) {
  return api.post(getConfirmServiceCallApiKeyUrl(), data).then((res) => res.data);
}

export function confirmRequestApiByGroup(data) {
  return api.post(getConfirmApiKeyListUrl(), data).then((res) => res.data);
}

export function revokeApiKeyApi(params, requestId) {
  return api.delete(getRevokeApiKeyUrl(requestId), { params }).then((res) => res.data);
}

export function getBusinessList(obj) {
  const params = { offset: 0, size: 10, ...obj };
  return api.get(getAllBusinessInfoUrl(), { params }).then((res) => res.data);
}
